<template>
	<div></div>
</template>

<script>
	export default{
		created() {
			window.location.replace('http://ke.uflyvision.com/');
		}
	}
</script>

<style>
</style>
